<template>
    <div id="contents" class="contents">

        <div class="breadcrumb">
            <ul>
                <li>
                    <router-link :to="{name: 'Index'}">TOP</router-link>
                </li>
                <li>
                    <span>Search result for</span>
                    <div class="d-inline" v-if="$globalState.searchedKeyword !== ''">
                        <span> {{ $globalState.searchedKeyword }}</span>
                    </div>
                </li>
            </ul>
        </div>

        <div class="grayBox">
            <div class="section-inner result-list">
                <article-collection></article-collection>
            </div>
        </div>
    </div>
</template>

<script>
    import ArticleCollection from "../../components/ArticleCollection/ArticleCollection";
    export default {
        name: "Articles",
        components: {ArticleCollection},
        beforeRouteEnter (to, from, next) {
            const keyword = to.query.keyword;
            next(vm => {
                if (keyword) {
                    vm.$globalState.searchConditions.keyword = keyword;
                }
                vm.searchArticles();
            });
        },
    }
</script>

<style src="./Articles.scss" lang="scss" scoped />

